"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AbstractMonth;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _colors = require("HubStyleTokens/colors");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatMediumMonthYear = _interopRequireDefault(require("I18n/utils/formatMediumMonthYear"));

var _SimpleDate = require("../../core/SimpleDate");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _H = _interopRequireDefault(require("../../elements/headings/H5"));

var _lazyEval = _interopRequireDefault(require("../../utils/lazyEval"));

var _Styles = require("../../utils/Styles");

/**
 * Moves values from the start of the array to the end.
 * @param {Array} arr
 * @param {Number} offset
 * @returns {Array}
 */
var rotateArrayBy = function rotateArrayBy(arr, offset) {
  var arrCopy = arr.slice();

  for (var i = 0; i < offset; i++) {
    var firstValue = arrCopy.shift();
    arrCopy.push(firstValue);
  }

  return arrCopy;
};
/**
 * Wrapper for the `SimpleDate` constructor that provides fallover if `month` is outside of the
 * valid range (0 - 11), using the native `Date` API.
 */


var safeSimpleDate = function safeSimpleDate(year, month, date) {
  var dateObject = new Date(year, month, date);
  return new _SimpleDate.SimpleDate(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate());
};
/**
 * @param {Number} year What year is it!?
 * @param {Number} month 0 for Jan, 1 for Feb, etc., à la Date
 * @param {Number} weekStartDay 0 for Sunday, 1 for Monday
 * @returns {Array} An array of arrays, where each array is a row of the calendar
 */


var computeWeeksOfMonth = function computeWeeksOfMonth(year, month, weekStartDay) {
  // Per the Date API convention, "date" = day of month, "day" = day of week.
  var monthStartDay = new Date(year, month).getDay();
  var monthEndDate = new Date(year, month + 1, 0).getDate();
  var weekEndDay = (weekStartDay + 6) % 7;
  var weeks = [[]]; // Get trailing dates from the previous month

  var startOffset = (monthStartDay - weekStartDay + 7) % 7 - 1;
  var prevMonthEndDate = new Date(year, month, 0).getDate();

  for (var date = prevMonthEndDate - startOffset; date <= prevMonthEndDate; date++) {
    weeks[0].push(safeSimpleDate(year, month - 1, date));
  }

  var week = 0;
  var day = monthStartDay;

  for (var _date = 1; _date <= monthEndDate; _date++) {
    weeks[week].push(safeSimpleDate(year, month, _date));

    if (day === weekEndDay) {
      week++;
      weeks.push([]);
    }

    day = (day + 1) % 7;
  } // Add leading dates for the next month until we have a full 6 weeks


  var endOffset = 7 * (6 - weeks.length) + 7 - weeks[week].length;

  for (var _date2 = 1; _date2 <= endOffset; _date2++) {
    weeks[week].push(safeSimpleDate(year, month + 1, _date2));

    if (day === weekEndDay && _date2 !== monthEndDate) {
      week++;
      weeks.push([]);
    }

    day = (day + 1) % 7;
  }

  return weeks;
};
/**
 * Returns the date corresponding to a Day from the DOM, based on its `data-` attrs.
 *
 * @param {HTMLElement} element
 * @returns {SimpleDate}
 */


var getDateForElement = function getDateForElement(element) {
  return new _SimpleDate.SimpleDate(+element.getAttribute('data-year'), +element.getAttribute('data-month'), +element.getAttribute('data-date'));
};
/**
 * Returns the locale-specific, formatted month-year string.
 *
 * @param {Number} year
 * @param {Number} month
 * @returns {String}
 */


var createFormattedMonthYear = function createFormattedMonthYear(month, year) {
  var dateValue = _I18n.default.moment({
    year: year,
    month: month
  });

  return (0, _formatMediumMonthYear.default)(dateValue);
};

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "AbstractMonth__Wrapper",
  componentId: "sc-130yvl0-0"
})(["cursor:default;width:260px;height:260px;"]);

var Header = _styledComponents.default.div.withConfig({
  displayName: "AbstractMonth__Header",
  componentId: "sc-130yvl0-1"
})(["display:flex;height:42px;align-items:center;"]);

var Heading = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "AbstractMonth__Heading",
  componentId: "sc-130yvl0-2"
})(["display:inline-block;margin:0 auto;"]);

var Table = _styledComponents.default.table.withConfig({
  displayName: "AbstractMonth__Table",
  componentId: "sc-130yvl0-3"
})(["width:100%;table-layout:fixed;border-collapse:collapse;text-align:center;font-size:15px;"]);

var WeekdayHeading = _styledComponents.default.th.withConfig({
  displayName: "AbstractMonth__WeekdayHeading",
  componentId: "sc-130yvl0-4"
})(["padding:7px 0;color:", ";", ";"], _colors.SLINKY, _Styles.FONT_FAMILIES.medium);

function AbstractMonth(props) {
  var focusedValue = props.focusedValue,
      maxValidationMessage = props.maxValidationMessage,
      minValidationMessage = props.minValidationMessage,
      children = props.children,
      disabledValues = props.disabledValues,
      leftControl = props.leftControl,
      max = props.max,
      min = props.min,
      month = props.month,
      onDateClick = props.onDateClick,
      onDateMouseEnter = props.onDateMouseEnter,
      onDateMouseLeave = props.onDateMouseLeave,
      ownerId = props.ownerId,
      rightControl = props.rightControl,
      today = props.today,
      weekdayHeadings = props.weekdayHeadings,
      weekStartDay = props.weekStartDay,
      year = props.year,
      rest = (0, _objectWithoutProperties2.default)(props, ["focusedValue", "maxValidationMessage", "minValidationMessage", "children", "disabledValues", "leftControl", "max", "min", "month", "onDateClick", "onDateMouseEnter", "onDateMouseLeave", "ownerId", "rightControl", "today", "weekdayHeadings", "weekStartDay", "year"]); // Convert year and month values to I18N timestamp to make use of format utils #8640

  var formattedMonthYear = (0, _react.useMemo)(function () {
    return createFormattedMonthYear(month, year);
  }, [month, year]);
  return _react.default.createElement(Wrapper, rest, _react.default.createElement(Header, null, leftControl, _react.default.createElement(Heading, {
    "aria-hidden": true
  }, formattedMonthYear), rightControl), _react.default.createElement(Table, {
    role: "presentation"
  }, _react.default.createElement("thead", {
    "aria-hidden": true
  }, _react.default.createElement("tr", null, rotateArrayBy(weekdayHeadings, weekStartDay).map(function (weekdayHeading, i) {
    return _react.default.createElement(WeekdayHeading, {
      key: i
    }, weekdayHeading);
  }))), _react.default.createElement("tbody", null, computeWeeksOfMonth(year, month, weekStartDay).map(function (week, i) {
    return _react.default.createElement("tr", {
      key: i
    }, week.map(function (simpleDate, index) {
      var lessThanMin = min && (0, _SimpleDate.compare)(simpleDate, min) === -1;
      var moreThanMax = max && (0, _SimpleDate.compare)(simpleDate, max) === 1;
      var inDisabledValues = disabledValues && disabledValues.some(function (disabledValue) {
        return (0, _SimpleDate.equals)(simpleDate, disabledValue);
      });
      var isDisabled = lessThanMin || moreThanMax || inDisabledValues;
      var isFocused = (0, _SimpleDate.equals)(simpleDate, focusedValue);
      return children(simpleDate, {
        id: ownerId + "-" + simpleDate.month + "-" + simpleDate.date,
        'data-date': simpleDate.date,
        'data-month': simpleDate.month,
        'data-year': simpleDate.year,
        key: index,
        role: 'menuitem',
        onClick: isDisabled ? undefined : function (evt) {
          onDateClick((0, _SyntheticEvent.default)(getDateForElement(evt.currentTarget)));
        },
        onMouseEnter: isDisabled || !onDateMouseEnter ? undefined : function (evt) {
          onDateMouseEnter((0, _SyntheticEvent.default)(getDateForElement(evt.currentTarget)));
        },
        onMouseLeave: isDisabled || !onDateMouseLeave ? undefined : function (evt) {
          onDateMouseLeave((0, _SyntheticEvent.default)(getDateForElement(evt.currentTarget)));
        },
        isCurrentMonth: simpleDate.month === month,
        isDisabled: isDisabled,
        isToday: (0, _SimpleDate.equals)(simpleDate, today),
        tooltip: (0, _lazyEval.default)(lessThanMin && minValidationMessage || moreThanMax && maxValidationMessage),
        tooltipOpen: isFocused || undefined
      });
    }));
  }))));
}

module.exports = exports.default;